// AMS FAQ/SSS içerikleri (Türkçe) — route modülü dışında tutulur, böylece route
// code-splitting bu modül seviyesindeki sabitleri kaldıramaz.

export const faqsTr: Array<[string, string]> = [
  [
    "Application Management Services (AMS) kapsamında neler yer alır?",
    "Application Management Services (AMS), canlı kurumsal sistemlerin sürekli işletilmesini kapsar: kullanıcı desteği, olay (incident) ve problem yönetimi, servis talepleri, fonksiyonel ve teknik düzeltmeler, izleme ve sürekli küçük iyileştirmeler — tek seferlik proje çalışmalarından farklı olarak.",
  ],
  [
    "AMS ile proje desteği arasındaki fark nedir?",
    "Proje desteği, rollout veya migrasyon gibi başlangıç ve bitiş tarihi belli bir girişimi kapsar. AMS ise sonrasında ortamı işler durumda tutan sürekli hizmettir; üzerinde anlaşılmış SLA'lar ve uzun vadeli bir ekiple yürütülür.",
  ],
  [
    "OXORY, AMS kapsamının yalnızca bir bölümünü devralabilir mi?",
    "Evet. OXORY, iç ekibinizin hâlihazırda üstlendiği işlere bağlı olarak tek bir destek seviyesini, belirli modülleri veya teknolojileri ya da eksiksiz L1–L3 zincirini kapsayabilir.",
  ],
  [
    "7/24 destek mümkün mü?",
    "Evet, iş açısından kritik olarak üzerinde anlaşılan sistemler ve süreçler için. Servis pencereleri, eskalasyon yolları ve tepki süreleri SLA'da tanımlanır.",
  ],
  [
    "AMS sağlayıcısı değişimi nasıl işler?",
    "Yapılandırılmış bir geçişle: mevcut kapsamın ve dokümantasyonun gözden geçirilmesi, bilgi aktarımı ve gölge (shadow) fazı, ardından ilk günden itibaren net sorumlulukla kontrollü bir cutover.",
  ],
];

/** /tr/hizmetler/ams/sap-yonetilen-hizmetler için FAQ/SSS — karşılaştırma ve satın alma amaçlı. */
export const managedServicesFaqsTr: Array<[string, string]> = [
  [
    "SAP managed services nedir?",
    "SAP managed services, tanımlı SAP uygulamalarının sürekli işletimini, üzerinde anlaşılmış servis seviyeleri karşılığında harici bir sağlayıcıya devretmek demektir. Sağlayıcı; anlaşılan kapsam için olay yönetimini, servis taleplerini, değişiklikleri ve izlemeyi üstlenir ve servis kalitesini raporlar — sizin yönetmek zorunda kalacağınız tek tek kişiler sağlamak yerine.",
  ],
  [
    "Managed services mi yoksa tek tek SAP freelancer'lar mı daha iyi?",
    "Tanımlı bir görev veya geçici bir kapasite açığı için freelancer daha hızlı ve daha ekonomik bir seçenektir. Sürekli işletim içinse managed services daha uygundur: bir kişi müsait olmadığında kapsama ortadan kalkmaz, bilgi ekip genelinde dokümante edilir ve servis seviyeleri sözleşmesel olarak sizin değil sağlayıcının sorumluluğundadır.",
  ],
  [
    "Birinci seviye desteği kendi bünyemizde tutabilir miyiz?",
    "Evet. Yaygın bir ayrım, işi ve kullanıcıları tanıyan iç servis masanızda L1'i bırakır; OXORY ise L2 ve L3'ü — fonksiyonel ve teknik çözüm, custom code ve entegrasyon çalışmalarını — üstlenir.",
  ],
  [
    "Bir SAP managed service'in devreye alınması ne kadar sürer?",
    "Yapılandırılmış bir geçiş genellikle birkaç hafta sürer: kapsam ve SLA incelemesi, bilgi aktarımı ve dokümantasyon kontrolü, mevcut ekip veya sağlayıcı yanında bir gölge (shadow) fazı, kontrollü cutover ve ardından düzenli servis değerlendirmeleriyle bir stabilizasyon fazı. Net süre, ortamın büyüklüğüne ve dokümantasyon kalitesine bağlıdır.",
  ],
  [
    "Mevcut custom code ve arayüzlerimize ne olur?",
    "Bunlar yönetilen kapsamın parçası hâline gelir. Geçiş sırasında custom geliştirmelerin ve arayüzlerin envanterini çıkarır, bilinen sorunları ve sahiplerini kayıt altına alır ve hangi kalemlerin bakımının yapılacağını, hangilerinin yeniden yazılacağını, hangilerinin devreden çıkarılacağını birlikte kararlaştırırız.",
  ],
  [
    "Managed services nearshore olarak sunulabilir mi?",
    "Evet. Aynı kapsam, Avrupa içindeki bir nearshore ekipten, örtüşen çalışma saatleriyle ve tek sözleşme üzerinden sunulabilir; destek saati başına maliyet belirleyici bir faktör olduğunda genellikle tercih edilen yol budur.",
  ],
];

/** /tr/hizmetler/ams/sap-ams-nedir için FAQ/SSS — açıklayıcı içerik amaçlı. */
export const whatIsAmsFaqsTr: Array<[string, string]> = [
  [
    "SAP AMS nedir?",
    "SAP AMS (Application Management Services), bir proje bittikten sonra canlı bir SAP ortamını çalışır durumda tutan sürekli hizmettir. Kullanıcı ve key-user desteğini, olay ve problem yönetimini, servis taleplerini, fonksiyonel ve teknik değişiklikleri, izlemeyi ve sürekli küçük iyileştirmeleri kapsar — tek seferlik proje işi olarak değil, üzerinde anlaşılmış servis seviyeleri karşılığında.",
  ],
  [
    "SAP'ta AMS neyin kısaltmasıdır?",
    "AMS, Application Management Services'in kısaltmasıdır. SAP bağlamında; altyapı hosting'i veya süresi belirli bir uygulama projesinden farklı olarak, SAP uygulamalarının — S/4HANA, ERP, EWM, TM, BTP entegrasyonu ve custom code — yönetilen desteğini ve bakımını tanımlar.",
  ],
  [
    "SAP AMS ile SAP Basis desteği arasındaki fark nedir?",
    "SAP Basis desteği teknik platforma odaklanır: sistem yönetimi, veritabanı operasyonları, transportlar, patch'leme ve performans. SAP AMS ise daha geniştir — Basis konularını içerir, ancak buna ek olarak iş modüllerinde fonksiyonel desteği, custom code bakımını, entegrasyon izlemeyi ve değişiklik yönetimini de kapsar; hepsi tanımlı servis seviyeleriyle birlikte.",
  ],
  [
    "AMS ile SAP managed services arasındaki fark nedir?",
    "Terimler örtüşür ve çoğu zaman birbirinin yerine kullanılır. Pratikte AMS uygulama katmanını (SAP uygulamalarının fonksiyonel ve teknik desteğini) vurgularken, managed services bazen altyapı ve hosting'i de kapsayacak şekilde daha geniş kullanılır. OXORY uygulama katmanını sunar ve gerektiğinde hosting sağlayıcınızla koordinasyon kurar.",
  ],
  [
    "Tipik SAP AMS servis seviyeleri nelerdir?",
    "Anlaşmaların çoğu talepleri dört önceliğe ayırır — kritik bir üretim kesintisinden planlı küçük değişikliklere kadar — ve her birine bir tepki ve çözüm hedefi bağlar. Servis pencereleri mesai saatlerinden genişletilmiş çalışma günü kapsamasına ve nöbete, iş açısından kritik sistemler için 7/24'e kadar uzanır.",
  ],
  [
    "SAP AMS nasıl fiyatlandırılır?",
    "Yaygın modeller şunlardır: anlaşılan kapsam ve servis seviyesi için sabit aylık ücret; aylık destek günü kotası olan ticket veya kapasite bazlı model; ya da temel servis ücretinin run faaliyetlerini karşıladığı, iyileştirmelerin ayrıca çağrıldığı hibrit bir model. Doğru model; ticket hacmine, sistem kritikliğine ve ortamınızın yıllık olarak absorbe ettiği değişim miktarına bağlıdır.",
  ],
  [
    "SAP AMS, iç ekip yerine ne zaman mantıklı olur?",
    "AMS genellikle şu durumlarda daha uygundur: ticket hacmi her modül için kalıcı uzman tutmayı gerektirmeyecek kadar düşükse, bilgi bir veya iki kişide toplanmışsa, mesai dışı kapsama gerekiyorsa ya da iç ekip tamamen proje işine ayrılmışsa ve iyileştirmelere hiç zaman kalmıyorsa.",
  ],
];
